import { FallbackImage } from './FallbackImage';

/** The words the runner app lays over a sponsored image: its scrim, the title, the subtitle and "Learn More". */
export function SponsoredCardText({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <span className="rq-app-card-text">
      <span className="rq-app-card-title">{title || '\u00a0'}</span>
      <span className="rq-app-card-subtitle">{subtitle || '\u00a0'}</span>
      <span className="rq-app-card-cta">
        Learn More <span aria-hidden="true">→</span>
      </span>
    </span>
  );
}

/** A sponsored card as the app's Discover tab shows it. The app's fonts differ, so line breaks are close. */
export function SponsoredCard({
  title,
  subtitle,
  src,
  fallbackSrc,
}: {
  title: string;
  subtitle: string;
  src?: string | null;
  fallbackSrc?: string | null;
}) {
  return (
    <figure className="rq-app-card">
      <FallbackImage
        src={src}
        fallbackSrc={fallbackSrc}
        missing={<span className="rq-app-card-empty rq-missing">No image</span>}
      />
      <SponsoredCardText title={title} subtitle={subtitle} />
    </figure>
  );
}
